const initialState = () => ({
  campaigns: [],
  pagination: {},
  status: null
})

export default initialState
